export const ACTIONS = {
  INPUT: "INPUT",
  BLUR: "BLUR",
  RESET: "RESET",
};
